/* QOWAA FIT — Page À PROPOS
   Reveal au scroll (IntersectionObserver sur .scroll-in) + carrousel atelier (dots mobile).
   Respecte prefers-reduced-motion. */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function initReveal(root) {
    var els = $all('.scroll-in', root);
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initCarousel(root) {
    $all('[data-qw-carousel]', root).forEach(function (car) {
      var track = $('.carousel__track', car);
      var dots = $all('.carousel__dot', car);
      if (!track || !dots.length) return;
      var n = $all('.carousel__slide', track).length;
      track.addEventListener('scroll', function () {
        var w = track.scrollWidth / n;
        var i = Math.round(track.scrollLeft / w);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var w = track.scrollWidth / n;
          track.scrollTo({ left: i * w, behavior: 'smooth' });
        });
      });
    });
  }

  function initAbout(root) { initReveal(root); initCarousel(root); }
  function boot() { $all('[data-qw-about]').forEach(initAbout); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-qw-about]'); if (r) initAbout(r); });
})();
